import * as React from "react";

const SvgIcnAttachment = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M20.125 10c.237 0 .442.088.615.264.173.176.26.384.26.625v8.222c0 .24-.087.45-.26.625a.833.833 0 01-.615.264H7.875a.833.833 0 01-.615-.264.862.862 0 01-.26-.625V10.89c0-.24.087-.45.26-.625a.833.833 0 01.615-.264h12.25zM20 11H8v8h12v-8zM9 18l2.5-3 1.974 2.368L16 14l3 4H9zm3.043-15c.27 0 .496.096.68.29A.984.984 0 0113 4v5h-1V4H8v4H4v8h2v1H3.957a.898.898 0 01-.68-.29A.977.977 0 013 16V7l4-4zM7 4.5L4.5 7H7V4.5z"
        />
    </svg>
);

export default SvgIcnAttachment;
